import { render } from "./FlipCoinMyHistory.vue?vue&type=template&id=3dd1eb68"
import script from "./FlipCoinMyHistory.vue?vue&type=script&lang=js"
export * from "./FlipCoinMyHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__